<template lang="pug">
  .gift-card-form
    .row
      form.giftcard-form(name="giftcardForm" @submit.prevent="onSubmit")
        transition(name="fade-giftcard")
          .xs-12.giftcard-container.pt-10.pb-50(v-if="showForm")
            .xs-12
              .row.mt-20.mb-30
                .xs-12.a-box-xs-8x5
                  .a-box-content
                    ImgBox(:mediaObj="giftCardImg")

              .row
                h4.text-color-1.bold.xs-font-xmedium.mb-10 {{ recipientHeader }}

              .row
                .xs-12
                  MrInput(
                    label="Recipient name"
                    name="recipientName"
                    v-model="giftCard.recipientName"
                    :v="v$.giftCard.recipientName"
                    :class="{ disabled: loading }"
                    :disabled="loading"
                    required
                    dataMrAss="recipient-name"
                  )

              .row
                .xs-12
                  MrInput(
                    label="Recipient email"
                    input-type="email"
                    name="recipientEmail"
                    v-model="giftCard.recipientEmail"
                    :v="v$.giftCard.recipientEmail"
                    :class="{ disabled: loading }"
                    :disabled="loading"
                    required
                    dataMrAss="recipient-email"
                  )

              .row.mt-20
                h4.text-color-1.bold.xs-font-xmedium.mb-10 {{ senderHeader }}

              .row
                .xs-12
                  MrInput(
                    label="Your name as it should appear on the card"
                    name="senderName"
                    v-model="giftCard.senderName"
                    :v="v$.giftCard.senderName"
                    :class="{ disabled: loading }"
                    :disabled="loading"
                    required
                    dataMrAss="sender-name"
                  )

              .row
                .xs-12
                  MrInput(
                    name="senderEmail"
                    label="Your email"
                    input-type="email"
                    v-model="giftCard.senderEmail"
                    :v="v$.giftCard.senderEmail"
                    :class="{ disabled: loading }"
                    :disabled="loading"
                    required
                    dataMrAss="sender-email"
                  )

              .row.text-center
                .xs-12
                  MrInput(
                    label="Note (max 250 characters)"
                    input-type="textarea"
                    name="note"
                    v-model="giftCard.note"
                    :v="v$.giftCard.note"
                    :class="{ disabled: loading }"
                    :disabled="loading"
                    :maxlength="250"
                    :rows="20"
                    required
                    dataMrAss="sender-email"
                  )

              .row.text-center.mt-20
                h4.text-color-1.bold.xs-font-xmedium.mb-10 {{ amountHeader }}

              .row.mb-10(v-for="(gc) in giftCards" :key="gc.id")
                MrRadio(v-model="giftCard.giftcardProduct" :value="gc" name="giftcard" @update:modelValue="showCustomAmountInputField(gc.price)")
                  label(:for="`giftcard-${gc.id}`") {{ `${gc.price > 0 ? '$' + gc.price : 'Custom Amount (Up to $'+ (gc.maxPrice || 500) + ')'}` }}
                  MrInput(
                      v-if="gc.price <= 0 && showCustomAmountField"
                      input-type="number"
                      name="customAmount"
                      v-model="giftCard.giftcardProduct.unitPrice"
                      :min="gc.minPrice || 25"
                      :max="gc.maxPrice || 500"
                      :v="{}"
                      :class="{ disabled: loading }"
                      :disabled="loading"
                      required
                      dataMrAss="custom-amount")

              .row.text-center.mt-20
                h4.text-color-1.bold.xs-font-xmedium.mb-10 {{ timingHeader }}

              .row.mb-20
                .row.mb-10
                  MrRadio(
                    v-model="giftCard.sendNow"
                    name="sendNow"
                    :value="true"
                    :class="{ disabled: loading }"
                    :disabled="loading"
                  )
                    label(for="sendNow") {{ sendNowText }}

                .row.send-at-container(@click="showCalendarModal")
                  MrRadio(
                    v-model="giftCard.sendNow"
                    name="sendLater"
                    :value="false"
                    :class="{ disabled: loading }"
                    :disabled="loading"
                  )
                    label(for="sendLater") {{ sendLaterText }}

                .row.send-at-container(
                  @click="showCalendarModal"
                  :class="{ 'text-color-3': giftCard.sendNow }"
                )
                  .xs-12
                    span.ml-50 Date:
                      span.bold.pl-10(v-if="giftCard.sendAt") {{ $formatDate(giftCard.sendAt, 'MM/DD/YYYY') }}
                      span.bold.pl-10(v-else) Please, choose a date.

                    MrIcon.pl-20(name="calendar" :fill="false" height="3em")

                  .xs-12
                    p.ml-50 Email will be sent at 12pm PT on selected date

              .row.text-center.mt-10.mb-10(v-if="loading")
                MrSpinner

              .row.text-center(v-else)
                button.mr-btn.btn-secondary.semi-bold.submit(
                  type="submit"
                  :class="{ disabled }"
                  :disabled="disabled"
                  data-mr-ass="submit-giftcard"
                ) {{submitText}}

        transition(name="fade-giftcard")
          .xs-12.giftcard-preview.mt-20.mb-50(
            v-if="!showForm"
          )
            .row
              h1.f-secondary.bold.upper.xs-f-large.sm-f-xxlarge.pb-5.text-center(v-html="reviewTitle")
              p.text-color-1.normal.text-center.xs-font-medium.mb-30(v-html="subTitle")

            .row.giftcard-preview-wrapper
              .xs-12.giftcard-container.mb-30
                .xs-12
                  p.text-color-1.bold.xs-font-small.sm-font-xmedium.md-font-xmedium.lg-font-xmedium.mb-10.text-center.upper.p-10-top(v-html="giftInfoHeader")

                  .xs-8.sm-6.xs-push-2.md-8.sm-push-3.md-push-2.a-box-xs-8x5
                    .a-box-content
                      ImgBox(:mediaObj="giftCardEnvelopeImg")

                  .xs-10.sm-8.xs-push-1.sm-push-2.text-center.xs-f-small.sm-font-medium.lg-font-medium.pt-10
                    p.bold
                      span.f-script.lower.xs-f-xsmall to:
                      span.upper &nbsp;{{ giftCard.recipientName }}

                    p.bold
                      span.f-script.lower.xs-f-xsmall from:
                      span.upper &nbsp;{{ giftCard.senderName }}

                    p.mt-10.light {{ giftCard.note }}

                .xs-12.gift-info.mt-30.mb-30
                  .xs-6.gift-amount
                    p.f-secondary.text-color-1.bold.text-right.vertical-align
                      span.xs-f-xxxlarge.sm-f-xxxlarge.md-f-grande.lg-font-grande.dola &#36;
                      span.xs-f-xxxgrande.sm-f-xxxgrande.md-f-poster.lg-font-poster {{ giftCard.giftcardProduct.price > 0 ? giftCard.giftcardProduct.price : giftCard.giftcardProduct.unitPrice }}

                  .xs-6.gift-code
                    p.semi-bold Gift Code:
                    p.bold XXXXXXXXXX
                    p Enter Code at Checkout

            .row
              .xs-12.sm-8.md-8.lg-12.sm-push-2.md-push-2.lg-push-0
                p.text-color-1.normal.text-center.xs-f-medium.sm-f-medium.md-font-medium.lg-font-medium.mt-30.mb-30 Your e-gift card email will be sent to {{ giftCard.recipientEmail }}
                  span(v-if="giftCard.sendAt && !giftCard.sendNow") &nbsp;on {{ $formatDate(giftCard.sendAt, 'MM/DD/YYYY') }}

            .row.text-center.mt-10.mb-10(v-if="loading")
              MrSpinner

            .row.text-center.buttons-container(v-else)
              button.mr-btn.btn-inverse(
                type="submit"
                :class="{ disabled }"
                :disabled="disabled"
              ) {{ submitText }}

              button.mr-btn.btn-tertiary(type="button" @click="hideForm") < back
</template>

<script>
  import dayjs from '@dayjs';
  import mask from '../../directives/mask';
  import { required, minLength, email } from '@vuelidate/validators';
  import { mapActions, mapState } from 'vuex';
  import MrInput from '@components/mrInput';
  import MrRadio from '@components/mrRadio';
  import MrSpinner from '@components/MrSpinner';
  import ImgBox from '@components/imgBox';
  import MrIcon from '@components/MrIcon';

  import vueGiftCardSvc from '@services/vueGiftCardSvc';
  import {useVuelidate} from "@vuelidate/core";

  export default {

    name: 'GiftCardForm',

    components: {
      MrInput,
      MrRadio,
      ImgBox,
      MrSpinner,
      MrIcon,
    },

    directives: {
      mask
    },

    props: {
      messages: {
        type: Object,
        default: () => ({
          giftCardAdded: 'Succesfully added gift card to your profile.',
          somethingWentWrong: 'Something went wrong, please try again or contact Color Crew',
          invalidFields: 'Please check your form for invalid fields',
        }),
      },
      giftCardImg: {
        type: Object,
        required: true,
      },
      recipientHeader: {
        type: String,
        required: true,
      },
      senderHeader: {
        type: String,
        required: true,
      },
      amountHeader: {
        type: String,
        required: true,
      },
      timingHeader: {
        type: String,
        required: true,
      },
      sendNowText: {
        type: String,
        required: true,
      },
      sendLaterText: {
        type: String,
        required: true,
      },
      submitText: {
        type: String,
        required: true,
      },
      reviewTitle: {
        type: String,
        required: true,
      },
      subTitle: {
        type: String,
        required: true,
      },
      giftInfoHeader: {
        type: String,
        required: true,
      },
      giftCardEnvelopeImg: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      loading: false,

      showForm: true,
      showCustomAmountField: false,

      giftCards: [],

      giftCard: {
        recipientName: null,
        recipientEmail: null,
        senderName: null,
        senderEmail: null,
        sendNow: true,
        sendAt: null,
        giftcardProduct: null,
      },
    }),

    setup () {
      return {
        v$: useVuelidate()
      };
    },

    computed: {
      ...mapState('cart', [
        'cart',
        'cartInitialized',
      ]),

      notSelectedDate() {
        return !this.giftCard.sendNow && !this.giftCard.sendAt;
      },

      disabled() {
        return this.v$.$invalid || this.loading || this.notSelectedDate;
      },
    },

    async mounted() {
      this.loading = true;
      try {
        if (!this.cartInitialized) {
          await this.loadCart();
        }
        await this.getAllGiftCards();
      } catch (error) {
        this.notifyError(this.messages.somethingWentWrong);
      }
      this.loading = false;
    },

    validations: {
      giftCard: {
        recipientName: {
          minLength: minLength(2),
          required
        },

        recipientEmail: {
          required,
          email
        },

        senderName: {
          minLength: minLength(2),
          required
        },

        senderEmail: {
          required,
          email
        },

        note: {
          required,
        },
      },
    },

    methods: {
      ...mapActions(['notifyError', 'notifySuccess']),
      ...mapActions('modal', ['showModal']),

      ...mapActions('cart', [
        'loadCart',
        'addToCart',
        'addCustomGiftCardToCart',
      ]),

      hideForm() {
        this.showForm = true;
        this.scrollTo('.gift-card-form');
      },

      showCustomAmountInputField(price) {
        if (price > 0){
          this.showCustomAmountField = false;
          return;
        }
        this.showCustomAmountField = true;
      },

      showCalendarModal() {
        this.showModal({
          component: "CalendarModal",
          props: {
            onConfirm: this.onDateChosen,
            minDate: new dayjs().add(1, 'days').toDate(),
            maxDate: new dayjs().add(3, 'months').toDate()
          },
          theme: null,
        });
      },

      async onDateChosen(date) {
        this.giftCard.sendNow = false;
        this.giftCard.sendAt = date;
      },

      async getAllGiftCards() {
        const { data: allGiftCards } = await vueGiftCardSvc.getAllGiftCards();

        //sort gift cards by price asc but only if price is greater than 0 and put the o price at the end
        this.giftCards = allGiftCards.sort((a, b) => {
          if (a.price === 0) {
            return 1;
          }
          if (b.price === 0) {
            return -1;
          }

          return a.price - b.price;
        });

        const { giftCard } = this.cart.items.find(({ giftCard }) => !!giftCard) || {};
        if (giftCard) {
          this.giftCard = { ...giftCard };
          this.giftCard.giftcardProduct = this.giftCards.find((card) => card.id === giftCard.giftcardProduct.id);
        } else {
          this.giftCard.giftcardProduct = this.giftCards[0];
        }

        this.showCustomAmountField = !this.giftCard.giftcardProduct.price > 0;
      },

      async onSubmit() {
        if (!this.showForm) {
          this.addGiftCardToCart();
          return;
        }

        this.v$.$touch();
        if (this.v$.$invalid) {
          return;
        }

        if (this.notSelectedDate) {
          this.notifyError('Please, choose a date using the calendar.');
          return;
        }

        this.validateGiftcard();
      },

      async addGiftCardToCart() {
        this.loading = true;
        const { giftcardProduct, sendNow } = this.giftCard || {};

        if (sendNow) {
          this.giftCard.sendAt = null;
        }

        const payload = {
          productId: giftcardProduct.id, // Whatever the ID for the gift card is
          qty: 1,
          subscription: 0,
          giftCard: this.giftCard,
        };

        try {
          if (giftcardProduct.price > 0){
            await this.addToCart(payload);
          } else {
            payload.unitPrice = this.giftCard.giftcardProduct.unitPrice;
            await this.addCustomGiftCardToCart(payload);
          }

          window.location = '/cart';
        } catch (error) {
          let errorMessage = this.messages.somethingWentWrong;
          if (error.data && error.data.message) {
            errorMessage = error.data.message;
          }
          this.notifyError(errorMessage);
        }
        this.loading = false;
      },

      async validateGiftcard() {
        this.loading = true;
        const { data } = await vueGiftCardSvc.validateGiftCard(this.giftCard);

        if (data.invalid) {
          this.loading = false;
          this.notifyError();
          return;
        }

        this.showForm = false;
        this.loading = false;
        this.scrollTo('.gift-card-form');
      },
    },
  };
</script>

<style lang="stylus">
  .gift-card-form
    max-width 43em
    margin auto
    padding-left 4%
    padding-right 4%
    padding-bottom 30px

    .send-at-container
      cursor pointer

    .buttons-container
      display flex
      flex-direction column

    .divider-line
      height 1px
      width 165px
      margin auto
      background-color #f00

    .gift-text
      padding 20px

    .gift-amount
      padding-right 3%
      border-right 1px solid #000

      .dola
        vertical-align top

    .gift-code
      padding-top 2%
      padding-left 3%

    .mobile-box
      margin -4%

    .gift-info
      > div
        min-height 70px

    .calendar
      display inline-block
      vertical-align middle
      line-height 45px

    form
      display flex

    .giftcard-container
      max-width 30em
      margin 0 auto

    input[name='sendDate']
      border 1px solid color-gray
      font-size 16px
      height 42px
      outline none
      padding 10px
      width 175px

    input[name='customAmount']
      width 20%

    textarea
      border 1px solid color-gray
      height 180px

    .back-button
      padding 15px
      display block
      width 90px
      margin auto

    .giftcard-preview
      .giftcard-preview-wrapper
        border 1px solid color-fog

        .giftcard-container
          width 100%
          max-width none

  @media mq-tablet-plus
    .giftcard-pdp
      padding-left 0
      padding-right 0

      .mobile-box
        margin auto

  .fade-giftcard-enter-active
    transition opacity 1s

  .fade-giftcard-leave-active
    transition opacity .0s

  .fade-giftcard-enter, .fade-giftcard-leave-to
    opacity 0

</style>